// $(document).ready(function() {
//   if ( $(window).width() < 767 ) {
//     startCarousel();
//   } else {
//     $('.owl-carousel').addClass('off');
//   }
// });

// $(window).resize(function() {
//     if ( $(window).width() < 767 ) {
//       startCarousel();
//     } else {
//       stopCarousel();
//     }
// });

// function startCarousel(){

// }
// function stopCarousel() {
//   var owl = $('.owl-carousel');
//   owl.trigger('destroy.owl.carousel');
//   owl.addClass('off');
// }

window.applyCarousel = function (jqueryObj, onEnd, endThreashold, disableFour) {
  if (!jqueryObj) {
    	return;
  }
    jqueryObj.owlCarousel({
    items:3,
    loop:false,
    margin:36,
    dots: false,
    nav: true,
    navText:['<svg width="9" height="14" viewBox="0 0 9 14" fill="none"> <path d="M8.25 12.1075L0.877971 7L8.25 1.89251V12.1075Z" stroke="white"/> </svg> ','<svg width="9" height="14" viewBox="0 0 9 14" fill="none"> <path d="M0.75 1.89251L8.12203 7L0.75 12.1075V1.89251Z" stroke="white"/> </svg> '],
    responsive:{
      0:{
        nav: true,
        items:1,
        margin:0,

      },
      768:{
        items:3

      },
      1000:{
        items: disableFour ? 3: 4 
      }
    }
  });
  jqueryObj.on('changed.owl.carousel', function(event) {
    const sizePerPage = event.page.size;
	const isLast = event.item.index + sizePerPage + (endThreashold || 0) === event.item.count;
    if (isLast && onEnd) {
      onEnd();
    }
  });
  jqueryObj.find('.43ratio').keepRatio({ ratio: 7/8, calculate: 'height' });
  return jqueryObj;
};

$(document).ready(function () {
  window.applyCarousel($(".recommended-carousel"));
  $('.detail-link').click(function(){
    $(this).toggleClass('active');
    $(".details_content").slideToggle(700);
  });

  $('.fade_in').fadeIn(4000);
  $('.43ratio').keepRatio({ ratio: 7/8, calculate: 'height' });

});